import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import React, { useContext } from 'react';
import { EditableInfoContainer } from '@dealstack/frontend/shared/components/EditableInfoContainer/EditableInfoContainer.tsx';
import { BankAccountTile } from '@dealstack/frontend/shared/components/BankAccountTile/BankAccountTile.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { PersonDataContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/hooks/usePersonData.ts';
import { BankAccountDeleteDrawer } from '@dealstack/frontend/shared/components/BankAccountDrawer/BankAccountDeleteDrawer.tsx';
import { BankAccountDrawer } from '@dealstack/frontend/shared/components/BankAccountDrawer/BankAccountDrawer.tsx';
import { useCapBankAccountDrawerProps } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/hooks/useCapBankAccountDrawerProps.ts';
import { useBankAccountLifecycleDebug } from '@dealstack/frontend/app/components/BankAccountLifecycleDebug/useBankAccountLifecycleDebug.tsx';

export const BankAccountSection = ({ hasEditorPermission }: { hasEditorPermission: boolean }) => {
	const tCapManage = useTranslationCapManage();
	const {
		bankAccounts,
		deleteBankAccount,
		setDeleteBankAccount,
		deletePersonBankAccount,
		deletePersonBankAccountLoading,
		deletePersonBankAccountSuccess,
		editBankAccount,
		setEditBankAccount,
		addBankAccount,
		setAddBankAccount,
	} = useContext(PersonDataContext);
	const { onInspect, drawer: lifecycleDebugDrawer } = useBankAccountLifecycleDebug();
	const bankAccountDrawerProps = useCapBankAccountDrawerProps();

	return (
		<>
			{bankAccounts.length ? (
				<EditableInfoContainer
					title={tCapManage('basic_details.bank_accounts.title')}
					isEdit={false}
					hasEditorPermission={hasEditorPermission}
					gridColumns={2}
					useGrid={true}
					childrenPadding="0.5rem"
					onAdd={() => setAddBankAccount(true)}
				>
					{bankAccounts.map((bankAccount) => (
						<BankAccountTile
							key={bankAccount.id}
							bankAccount={bankAccount}
							onRemove={setDeleteBankAccount}
							onEdit={setEditBankAccount}
							hasEditPermission={hasEditorPermission}
							onInspect={onInspect}
							showStatusBadge
							tileTestId={TEST_ELEMENT_IDS.CAP_BANK_ACCOUNT_TILE}
							editBtnTestId={TEST_ELEMENT_IDS.EDITABLE_TILE_EDIT_BUTTON}
							deleteBtnTestId={TEST_ELEMENT_IDS.EDITABLE_TILE_DELETE_BUTTON}
							statusBadgeTestId={TEST_ELEMENT_IDS.CAP_BANK_ACCOUNT_TILE}
						/>
					))}
				</EditableInfoContainer>
			) : null}

			{lifecycleDebugDrawer}

			{hasEditorPermission && (
				<>
					<BankAccountDrawer
						{...bankAccountDrawerProps}
						opened={addBankAccount}
						onClose={() => setAddBankAccount(false)}
						hasPermission={hasEditorPermission}
						bankAccount={null}
					/>

					<BankAccountDrawer
						{...bankAccountDrawerProps}
						opened={!!editBankAccount}
						onClose={() => setEditBankAccount(null)}
						hasPermission={hasEditorPermission}
						bankAccount={editBankAccount}
					/>

					<BankAccountDeleteDrawer
						opened={!!deleteBankAccount}
						onClose={() => setDeleteBankAccount(null)}
						bankAccount={deleteBankAccount}
						handleDelete={deletePersonBankAccount}
						deleteLoading={deletePersonBankAccountLoading}
						deleteSuccess={deletePersonBankAccountSuccess}
					/>
				</>
			)}
		</>
	);
};
